import { render, staticRenderFns } from "./ColourSpecimenSettings.vue?vue&type=template&id=049ba498&scoped=true"
import script from "./ColourSpecimenSettings.vue?vue&type=script&lang=js"
export * from "./ColourSpecimenSettings.vue?vue&type=script&lang=js"
import style0 from "./ColourSpecimenSettings.vue?vue&type=style&index=0&id=049ba498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049ba498",
  null
  
)

export default component.exports